// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"30cb943b","762":"b0051c68"}[chunkId] + ".chunk.js";
};